<template>
	<div>
    <modalconfirm ref="modalSRE" @action="proccessSRE"/>
		<modalDetail :dialog="dialog" @hideDialog="() => { dialog = false }"></modalDetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5" v-if="$route.name == 'list-sales-retail-employee'">Data Penjualan Karyawan</div>
			<div class="text-h5" v-else-if="$route.name == 'list-sales-retail-employee-warehouse'">Data Penjualan Karyawan Warehouse</div>
		</div>
		<div v-if="loading">
			<loading-card></loading-card>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3" outlined>
				<v-list color="deep-purple lighten-5" class="pa-3">
					<v-list-item dense class="px-1">
						<router-link class="text-deco" :to="{ name: 'add-sales-retail-employee' }" v-if="hasAccess('add-sales-retail-employee')">
							<v-btn light depressed class="primary">
								<v-icon>mdi-plus-circle</v-icon>
								<div class="pl-2 text-capitalize">Tambah Penjualan</div>
							</v-btn>
						</router-link>
						<v-spacer></v-spacer>
						<v-btn text depressed class="primary mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mt-3" v-if="dropfilter">
					<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-if="listSRE.length == 0 && srePagination" class="mt-3">
				<div class="py-3">
					<not-found></not-found>
				</div>
			</v-card>
			<div v-else>
				<v-row class="mr-0">
					<v-col cols="12" md="12" class="pb-0 pr-0" v-for="listsre in listSRE" :key="listsre.sre_id">
						<v-card outlined>
							<v-list color="deep-purple lighten-5" class="pt-0 pb-0">
								<v-list-item dense>
									<v-list-item-content class="grey--text text--darken-2">
										Kode Penjualan {{ listsre.sre_code }}
									</v-list-item-content>
									<v-spacer></v-spacer>
									<v-btn small text depressed class="primary" @click="printSRE(userData.user_warehouse_id, listsre.sre_code)">
										<v-icon>mdi-printer</v-icon>
										<div class="pl-2 text-capitalize">Print</div>
									</v-btn>
								</v-list-item>
							</v-list>
							<v-list-item>
								<v-list-item-content>
									<v-layout wrap>
										<v-flex xs6 sm3 md3 class="pr-3">
											<div class="body-2 oppacity-75">Nomor Induk Karyawan</div>
											<div class="subtitle-2">{{ listsre.sre_buyer_nip }}</div>
											<div class="body-2 pt-3 oppacity-75">Nama Karyawan</div>
											<div class="subtitle-2">{{ listsre.sre_buyer_name }}</div>
											<div v-if="$route.name == 'list-sales-retail-employee-warehouse'" class="body-2 pt-3 oppacity-75">Warehouse</div>
											<div v-if="$route.name == 'list-sales-retail-employee-warehouse'" class="subtitle-2">{{ listsre.warehouse_name }}</div>
										</v-flex>
										<v-flex xs6 sm5 md5 class="pr-3">
											<div class="body-2 oppacity-75">Tanggal Transaksi</div>
											<div class="subtitle-2">{{ listsre.sre_datetime | tanggaljam }}</div>
											<div class="body-2 pt-3 oppacity-75">Catatan Pembayaran</div>
											<div class="subtitle-2" v-html="listsre.sre_payment_note"></div>
										</v-flex>
										<v-flex xs6 sm4 md4 class="pr-3">
											<div class="body-2 oppacity-75">Nomor Handphone</div>
											<div class="subtitle-2">{{ listsre.sre_buyer_mobilephone }}</div>
											<div class="pt-5">
                        <span class="body-2 mr-2">{{listsre.sre_status | toSREStatus}}</span>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="teal lighten-2" v-bind="attrs" v-on="on" @click.stop="getDetail(listsre.sre_code)">
															<v-icon dark>mdi-text-box-search</v-icon>
														</v-btn>
													</template>
													<span>Detail</span>
												</v-tooltip>
                        <v-tooltip bottom v-if="listsre.sre_status == 'approved' && listsre.sre_warehouse_id == userData.user_warehouse_id">
													<template v-slot:activator="{ on, attrs }">
														<v-btn class="mr-2" fab dark x-small depressed color="primary" v-bind="attrs" v-on="on" @click.stop="close(listsre.sre_id)">
															<v-icon dark>mdi-check</v-icon>
														</v-btn>
													</template>
													<span>Konfirmasi</span>
												</v-tooltip>
											</div>
										</v-flex>
									</v-layout>
								</v-list-item-content>
							</v-list-item>
							<div class="pt-2">
								<v-card tile elevation="0">
									<v-data-table :headers="headersProduct" :items="listsre.sre_detail" :items-per-page="1000" class="elevation-0 white-row" hide-default-footer>
										<template v-slot:item.sre_detail_quantity="{ item }">
											<div>{{ item.sre_detail_quantity | toNumber }}</div>
										</template>
										<template v-slot:item.sre_detail_product_price="{ item }">
											<div>Rp {{ item.sre_detail_product_price | toNumber }}</div>
										</template>
									</v-data-table>
								</v-card>
							</div>
						</v-card>
					</v-col>
				</v-row>
			</div>
			<div class="pt-5">
				<v-row v-if="srePagination.total_page">
					<v-col cols="12" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-model="page" @input="changePage" :length="srePagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus"></v-pagination>
					</v-col>
					<v-col cols="12" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import modalDetail from '@/views/MLwarehouse/sre/DetailSRE'
import modalPrint from '@/views/MLwarehouse/sre/PrintSRE'
import { mapActions,  mapState, mapMutations } from 'vuex'

const allWarehouse = {
	warehouse_name: 'Semua Warehouse',
	warehouse_id: ''
}

export default {
	inject: ['theme'],
	components: {
		modalDetail, modalPrint
	},
	data() {
		return {
      sreProccessID: '',
      sreProccessAction: '',
			dialog: false,
			dialogPrint: false,
			dropfilter: false,
			menuDateCreate: false,
			loading: true,
			tanggalDibuat: [],
			page: 1,
			limit: 10,
			listLimit: [ 5, 10, 20, 50, 100 ],
			params: [],
			headersProduct: [
			{ text: 'Nama Produk', value: 'sre_detail_product_name', sortable: false, width: '30%' },
			{ text: 'Kode Produk', value: 'sre_detail_product_code', sortable: false, width: '15%' },
			{ text: 'Harga', value: 'sre_detail_product_price', sortable: false, align: 'center', width: '10%' },
			{ text: 'Jumlah', value: 'sre_detail_quantity', sortable: false, align: 'center', width: '10%' },
			],
			filterData: [{
				type: 'text',
				label: 'Kode Transaksi',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'sre_code'
				}
			}, {
				type: 'text',
				label: 'Nama Karyawan',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'sre_buyer_name'
				}
			}, {
				type: 'date',
				label: 'Tanggal Pembelian',
				filter: {
					value: [],
					comparison: 'bet',
					type: 'date',
					field: 'sre_datetime'
				}
			}, {
				type: 'selection',
				label: 'Warehouse',
				item: [allWarehouse],
				itemValue: 'warehouse_id',
				itemText: 'warehouse_name',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'sre_warehouse_id'
				}
			},
			],
		}
	},
	computed: {
		...mapState('sre', ['listSRE', 'srePagination', 'warehouseResults', 'response']),
		...mapState('auth', ['userData']),
	},
	methods: {
		...mapActions('sre', ['getSRE', 'getSREAll', 'approveSRE', 'getDetailSRE', 'exportSRE', 'exportSREAll', 'getOptionWarehouse']),
		...mapMutations('sre', ['clearDataSRE']),
		...mapMutations(['setFilter', 'setOverlay']),
		...mapActions('common', ['getLetterHeader']),

		getData() {
			if (this.$route.name == 'list-sales-retail-employee')
				this.getSRE(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					this.loading = false
				})
			else if (this.$route.name == 'list-sales-retail-employee-warehouse')
				this.getSREAll(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir})).then(() => {
					this.loading = false
				})
		},
		exportData() {
			if (this.$route.name == 'list-sales-retail-employee')
				this.exportSRE(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
			else if (this.$route.name == 'list-sales-retail-employee-warehouse')
				this.exportSREAll(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			this.params = []
			this.getData()
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		getDetail(code) {
			this.getDetailSRE({
				sre_code: code
			}).then(()=> {
				this.dialog = true
			})
		},
		async printSRE(id, code) {
			await this.getLetterHeader({warehouse_id: id})
			await this.getDetailSRE({
				sre_code: code
			}).then(()=> {
				this.dialogPrint = true
			})
		},
    close(sre_id){
      this.sreProccessID = sre_id
			this.sreProccessAction = 'closed'
			let msg = "Yakin akan memproses Penjualan ini?"
			this.$refs.modalSRE.setMessage(msg)
			this.$refs.modalSRE.showConfirm()
		},
    async proccessSRE() {
			await this.setOverlay(true)
			await this.$refs.modalSRE.hideConfirm()
      await this.approveSRE({
        sre_id: this.sreProccessID,
        status: this.sreProccessAction,
      }).then(() => {
        if (this.response.code == 200) {
          this.resetForm()
        }
        this.getData()
      })

			await this.setOverlay(false)
		},
    resetForm () {
      this.sreProccessID = ''
      this.sreProccessAction = ''
    }
	},
	async created() {
		let indexWarehouse = await this.filterData.findIndex(el => el.label == 'Warehouse')
		this.filterData[indexWarehouse].item = [allWarehouse, ...await this.getOptionWarehouse()]
		await this.setFilter(this.filterData)
		await this.getData()

		this.$store.dispatch('setPageTitle', `Penjualan Karyawan`)
	},
	beforeDestroy() {
		this.clearDataSRE()
	},
	watch: {
		tanggalDibuat(val) {
			this.dateCreatedSRE.value = val
		},
		$route() {
			this.onResetFilter()
		}
	}
};
</script>
